import "../css/theme.css";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "../OAS365Theme";

export const useGridStyle = () => {
  const theme = useTheme();

  const gridStyle = {
    headerStyle: useGridHeaderStyle(theme),
    headerCellStyle: useGridHeaderCellStyle(theme),
    borderStyle: useGridBorderStyle(theme),
    rowStyle: useGridRowStyle(theme),
    rowSelectedStyle: useGridRowSelectedStyle(theme),
    headerCellStyleRegular: useGridHeaderStyleRegular(theme),
    detailListStyle:useDetailListStyle(theme),
    stackStyle:useStackStyle(theme),
    recentlyUsedGridStyle : recentlyUsedGridStyle(theme)
  }
  return gridStyle;
};

const useGridBorderStyle = (theme) => {
  const style = {
    // border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: 8,
    marginRight: 0,
    //paddingTop: 4,
    //paddingBottom: 4, 
    background: theme.colors.backgroundColor
  };
  return style;
};

const useGridHeaderStyle = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ":hover": {
          background: theme.colors.backgroundColor,
          color: `${theme.colors.fontColor}!important`,
        },
        ".ms-DetailsHeader": {
          paddingTop: 2,
          background: "red",
        },
        ".ms-DetailsHeader-cellName": {
          fontSize: theme.fontSizes.normal,
          fontFamily: theme.fonts.regular,
          fontWeight: theme.fontWeight.titleWeight,
          color: theme.colors.fontColor,
        },
        ".stickyAbove-217":{
          background: theme.colors.backgroundColor,
          color: `${theme.colors.fontColor}!important`,
        },
        ".ms-FocusZone": {
          background: theme.colors.backgroundColor,
        },
        ".ms-DetailsRow-cell": {
          fontSize: theme.fontSizes.normal,
          fontFamily: theme.fonts.regular,
          color: `${theme.colors.fontColor}!important`,
          background: theme.colors.backgroundColor,
        },
        ".ms-Check-check": {
          background: theme.colors.themeDarkColor,
          borderRadius: '50%',
          paddingLeft: '1px',
        },
        ".ms-DetailsHeader-cellTitle": {
          background: theme.colors.backgroundColor
        },
        ".ms-DetailsHeader-cellTitle:hover": {
          background: `${theme.colors.backgroundColor}!important`,
          color: `${theme.colors.fontColor}!important`,
        },
        ".ms-DetailsHeader-cell.is-actionable:hover": {
          background: `${theme.colors.backgroundColor}!important`,
          ".ms-DetailsHeader-cellTitle": {
            background: "inherit",
          }
        }
      },
      background: theme.colors.backgroundColor,
    },
  });
};

const useGridHeaderStyleRegular = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-DetailsHeader": {
          paddingTop: 2,
        },
        ".ms-DetailsHeader-cellName": {
          fontSize: theme.fontSizes.normal,
          fontFamily: theme.fonts.regular,
          fontWeight: theme.fontWeight.menuWeight,
          color: theme.colors.fontColor,
        },
        ".ms-Check-check": {
          background: theme.colors.themeDarkColor,
          // border: `0px solid ${theme.colors.borderColor}`,
          borderRadius: 15,
          paddingLeft: '1px',
        },
        ".ms-DetailsHeader-cellSizer": {
          // background: theme.colors.borderColor,
          width: '1px',
          marginRight: '8px'
        },
      },
      // background: theme.colors.backgroundColor,
      paddingTop: 0,
      paddingBottom: 0,
    },
  });
};

const useGridHeaderCellStyle = (theme) => {
  return mergeStyleSets({
    root: {
      headerCellStyle:theme.colors.backgroundColor,
      selectors: {
        ":hover": {
          background: theme.colors.backgroundColor,
        },
      }
    },
  });
};

const useGridRowSelectedStyle = (theme) => {
  
  return mergeStyleSets({
    root: {
      width: 'auto',
      background: theme.colors.backgroundColor,
      selectors: {
        ":hover": {
          background: `${theme.colors.msTeamsFilesHover}`,
          color: `${theme.colors.fontColor}!important`,
        },
        ".ms-DetailsRow-cell": {
          fontSize: theme.fontSizes.normal,
          fontFamily: theme.fonts.regular,
          fontStyle: "normal",
          fontWeight: theme.fontWeight.normal,
          lineHeight: theme.lineHeight.grid,
          color: `${theme.colors.fontColor}!important`,
          background: theme.colors.backgroundColor,
        },
        ".ms-Check-check": {
          background: theme.colors.themeDarkColor,
          borderRadius: 15,
          paddingLeft: '1px',
        },
        '.ms-FocusZone .css-176 ms-DetailsRow .is-selected .is-contentUnselectable .root-421':{
          background: theme.colors.backgroundColor,
        },
      },
    },
  });
};

const useGridRowStyle = (theme) => {
  return mergeStyleSets({
    root: {
      width: 'auto',
      selectors: {
        ":hover": {
          background: `${theme.colors.themeColor} !important`, // selected hover color
        },
        ".ms-DetailsRow-cell": {
          fontSize: theme.fontSizes.normal,
          fontFamily: theme.fonts.regular,
          fontStyle: "normal",
          fontWeight: theme.fontWeight.normal,
          lineHeight: theme.lineHeight.grid,
        },
        ".ms-Check-check": {
          background: theme.colors.themeDarkColor,
          borderRadius: 15,
          paddingLeft: '1px',
        },
        ".ms-FocusZone ms-DetailsRow is-selected is-contentUnselectable":{
          background: theme.colors.backgroundColor,
        },
      },
    },
  });
};

const useDetailListStyle = (theme) => {
  return mergeStyleSets({
    root: {
      overflowX: "hidden",
      selectors: {
        ".ms-DetailsRow": {
          backgroundColor: `${theme.colors.backgroundColor}!important`,
          color: theme.colors.fontColor,
        },
        /** Match row context menu hover (same as theme.colors.contextMenuHover). */
        ".ms-DetailsRow:not(.is-selected):hover": {
          backgroundColor: `${theme.colors.msTeamsFilesHover}!important`,
          color: theme.colors.fontColor,
        },
        ".ms-Button--hasMenu:hover": {
          backgroundColor: `${theme.colors.backgroundColor }!important`,
        },
        ".ms-DetailsRow.is-selected, .ms-DetailsRow.is-selected:hover": {
          backgroundColor: `${theme.colors.contextMenuHover}!important`,
          color: theme.colors.fontColor,
        },
        ".ms-DetailsRow.is-selected .ms-DetailsRow-cell": {
          color: `${theme.colors.fontColor}!important`,
        },
        "is-actionable":{
          backgroundColor: `${theme.colors.msTeamsFilesHover}!important`,
          color: `${theme.colors.mainAreaBackgroundColor}!important`,
        },
        ".ms-DetailsHeader-cellName": {
          fontFamily: "Poppins, sans-serif !important",
        },
        ".ms-DetailsHeader": {
          backgroundColor: `${theme.colors.backgroundColor}!important`,
          color: theme.colors.fontColor,
        },
        ".ms-Check-check": {
          background: theme.colors.themeDarkColor,
          borderRadius: 15,
          paddingLeft: "1px",
        },
        "ms-DetailsHeader-cellIsCheck":{
          background: theme.colors.themeDarkColor,
        },
        ".ms-DetailsRow-cell": {
          alignContent: "center",
          fontSize: theme.fontSizes.normal,
          fontFamily: theme.fonts.regular,
          fontStyle: "normal",
          fontWeight: theme.fontWeight.normal,
          lineHeight: theme.lineHeight.grid,
          color: `${theme.colors.themeFontColor}!important`,
        },
        ".ms-DetailsHeader-cellTitle":{
          backgroundColor:`${theme.colors.backgroundColor }!important`,
          color: `${theme.colors.fontColor}!important`,
          fontFamily: "Poppins, sans-serif !important",
        },
        ".ms-Button-textContainer":{
          // color: `${theme.colors.themeFontColor}!important`,
          background: theme.colors.themeDarkColor,
        },
        ".cellTooltip-303, .cellTooltip-311":{
          backgroundColor: `${theme.colors.backgroundColor }!important`,
          color: `${theme.colors.themeFontColor}!important`,
        },
        ".root-275":{
          background:"none"
        },
        ".root-277":{
          background:"none"
        },
        ".cellTooltip-321:hover":{
          backgroundColor: `${theme.colors.backgroundColor }!important`,
          color: `${theme.colors.themeFontColor}!important`,
        },
        ".root-345:hover":{
          background: theme.colors.backgroundColor,
        },
        ".ms-DetailsHeader-cell.is-actionable.is-empty":{
          backgroundColor: `${theme.colors.backgroundColor }!important`,
          fontFamily: "Poppins, sans-serif !important",
        },
        ".ms-Button.ms-Button--icon.is-expanded.ms-Button--hasMenu":{
          backgroundColor: `${theme.colors.backgroundColor }!important`,
        },
        ".checkedOutLock:hover":{
          display: "none",
        },
        ":global(.ms-Button.ms-Button--icon:hover)": {
            backgroundColor: "transparent",
            color: `${theme.colors.fontColor}!important`,
        },
      },
    },
  });
};

const useStackStyle = (theme) => {
  return mergeStyleSets({
    root: {
      background: theme.colors.backgroundColor,
    },
  });
};

const recentlyUsedGridStyle = (theme) => {
  return mergeStyleSets({
    root: {
      width: "100%",
      maxWidth: "100%",
      overflowX: "hidden",
      boxSizing: "border-box",
      selectors: {
        ".ms-DetailsRow-check": {
          visibility: "hidden",
        },
        ".ms-DetailsRow:hover": {
          backgroundColor: `${theme.colors.msTeamsFilesHover}!important`,
          fontColor:`${theme.colors.fontColor}!important`,
        },
        ".ms-Button-flexContainer:hover": {
          backgroundColor: `${theme.colors.msTeamsFilesHover}!important`,
          color:`${theme.colors.fontColor}!important`,
        },
        ".ms-Button-flexContainer": {
          marginLeft: "-68px",
        },
        ".ms-DetailsRow":{
          backgroundColor: `${theme.colors.mainAreaBackgroundColor}!important`,
          fontColor:`${theme.colors.fontColor}`,
        },
        ".ms-Button": {
          fontFamily: theme.fonts.regular,
          fontSize: "12px",
          marginTop: "-10px",
        },
        ".ms-Button:disabled": {
          backgroundColor: "transparent",
        },
        ".ms-Button:selected ": {
          backgroundColor: `${theme.colors.themeColor}!important`,
        },
        ".ms-DetailsRow:selected:hover": {
          backgroundColor: `${theme.colors.themeColor}!important`,
        },
        ".ms-DetailsHeader-cellName": {
          fontFamily: theme.fonts.regular,
          backgroundColor: `${theme.colors.mainAreaBackgroundColor}!important`,
          color:`${theme.colors.fontColor}`,
        },
        ".ms-DetailsRow-cell": {
          fontFamily: theme.fonts.regular,
          fontSize: "14px",
          color:`${theme.colors.fontColor}!important`,
        },
        ".ms-FocusZone":{
          backgroundColor: `${theme.colors.mainAreaBackgroundColor}!important`,
        },
        ".ms-FocusZone:hover":{
          backgroundColor: `${theme.colors.mainAreaBackgroundColor}!important`,
        },
        ".ms-DetailsHeader-cellSizer":{
          backgroundColor: `${theme.colors.mainAreaBackgroundColor}!important`,
        },
        ".ms-DetailsHeader-cellTitle":{
          backgroundColor: `${theme.colors.mainAreaBackgroundColor}!important`,
        }
        
      },
    },
  });
}
